<div class="relative">
  <div [class.invisible]="loading">
    <ng-content></ng-content>
  </div>
  <div
    aria-label="Trwa ładowanie"
    [class.visible]="loading"
    [class.invisible]="!loading"
    class="absolute flex items-center justify-center inset-0 w-full h-full"
  >
    <ng-container [ngComponentOutlet]="spinnerComponent"></ng-container>
  </div>
</div>
